const state = {
   permisos: null,
   backgroundColor: null,

};

export default state;